import React from 'react';
import './styles/App.css';
import { Routes } from './Routes';

const App: React.FC = () => (
  <Routes />
);

export default App;